import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import plAuth from './locales/pl/auth.json';
import plCommon from './locales/pl/common.json';
import plStart from './locales/pl/start.json';
import plTournament from './locales/pl/tournament.json';

/**
 * Konfiguracja tlumaczen.
 *
 * Aplikacja jest dzis wylacznie po polsku, ale wszystkie teksty od poczatku
 * siedza w plikach lokalizacyjnych. Dodanie kolejnego jezyka sprowadza sie
 * wtedy do dorzucenia katalogu `locales/<kod>` i wpisu w `resources` —
 * bez przepisywania komponentow.
 */

export const defaultNS = 'common';
export const supportedLanguages = ['pl'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const resources = {
  pl: {
    common: plCommon,
    auth: plAuth,
    start: plStart,
    tournament: plTournament,
  },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: 'pl',
  fallbackLng: 'pl',
  defaultNS,
  ns: ['common', 'auth', 'start', 'tournament'],
  interpolation: {
    // React sam zabezpiecza wstawiane wartosci przed XSS.
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
